import { getTotalStopTime } from '../../util';
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import { getStopDetails } from "./utils";
import constants from "./constants";
import StopTime from "./common/CompletedStopTimeRenderer";


const CompletedStopPopup = ({ task }) => {
  const { stopStatus, stopStatusClass } = getStopDetails(task.data);
  const plannedStopTime = getTotalStopTime(
    task?.data?.plannedArrivalTime,
    task?.data?.plannedDepartureTime
  )
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      arrivalTime={task.arrivalTime}
      departureTime={task.departureTime}
      stopTime={<StopTime actualStopTime={task.stopDuration} plannedStopTime={plannedStopTime} />}
      stopTimeClass="completedStopTime"
      stopTimeHeaderClass="completedStopTimeHeader"
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={stopStatusClass}
      serviceWindow={task?.data}
      stopData={task.data}
    />
  );
};

export default CompletedStopPopup;
